import { h, Component } from "preact";
import { push_ga_event } from "../../utils/ga";
import { gettext as _ } from "../../utils/i18n"; // FIX: Otherwise form.js raise unexpected exception. Very weird. Can be removed after migration to Parcel 2
import QuoteAPI from "../../services/QuoteAPI";
import { StoredSet } from "../../services/Storage";
import { delete_cookie, readCookie } from "../../utils/cookies"; // FIX: Otherwise form.js raise unexpected exception. Very weird. Can be removed after migration to Parcel 2

// fix undeclared variable in window
declare global {
    interface Window {
        LANGUAGE_CODE: string;
        USER_IS_AUTHENTICATED: string;
        _likes: StoredSet | Set<number>;
        URLS: {
            facebook_login: string;
            account_login: string;
            account_signup: string;
        };
    }
}

// Cookies are deprecated from December 2020
const LIKES_COOKIES_NAME = "quotes.quote.like";

function get_likes_from_cookie() {
    const votes_string = readCookie(LIKES_COOKIES_NAME);
    if (votes_string) {
        return votes_string.split(".").map(function (value) {
            return parseInt(value);
        });
    } else {
        return [];
    }
}

function delete_likes_from_cookie() {
    delete_cookie(LIKES_COOKIES_NAME);
}

function get_likes_set() {
    /* singleton instance for likes stored in local storage */

    const storage = window.localStorage;
    const storage_key = "quotepark_likes";

    if (!window._likes) {
        if (window.USER_IS_AUTHENTICATED) {
            // do not save likes to local storage for authenticated users
            window._likes = new Set();

            // remove any likes from localstorage
            storage.removeItem(storage_key);
        } else {
            const initial_value = get_likes_from_cookie() || [];

            // if initial data loaded from cookie, destroy cookie
            if (initial_value) {
                delete_likes_from_cookie();
            }

            // do initial save only if default is not empty
            const save_initial = Boolean(initial_value);

            window._likes = new StoredSet(storage, storage_key, initial_value, save_initial);
        }
    }

    return window._likes;
}

interface Props {
    content_type: string;
    id: number;
    like_count: number;
    liked: boolean;
}

interface State {
    liked: boolean;
    like_count: number;
}

export default class LikeButton extends Component<Props, State> {
    likes_set: StoredSet | Set<number>;

    constructor(props) {
        super(props);

        // init storage for likes
        this.likes_set = get_likes_set();
        if (this.likes_set.has(props.id)) {
            props.liked = true;
            if (props.like_count == 0) {
                // prevent 0 likes, if user voted.
                props.like_count += 1;
            }
        }

        this.state = {
            like_count: props.like_count || 0,
            liked: props.liked || false,
        };
    }

    vote(e: MouseEvent) {
        const vote_type = this.state.liked ? "none" : "like";

        // send vote
        QuoteAPI.vote(this.props.content_type, this.props.id, vote_type).then(() => {
            // track vote in google analytics
            push_ga_event(this.props.content_type, vote_type, "#" + this.props.id);
        });

        // set state
        if (!this.state.liked) {
            this.setState((state) => ({
                liked: true,
                like_count: state.like_count + 1,
            }));

            this.likes_set.add(this.props.id);

            // show promo login, when user is not authenticated
            // TODO: This is wrong! Refactor to some more react solution
            if (!window.USER_IS_AUTHENTICATED) {
                import("../LoginModal/LoginModal").then((LoginModalModule) => {
                    LoginModalModule.default.open({ force: false });
                });
            }
        } else {
            this.setState((state) => ({
                liked: false,
                like_count: state.like_count - 1,
            }));

            this.likes_set.delete(this.props.id);
        }

        e.preventDefault();
    }

    render(props: Props, state: State) {
        const aria_label = _("Like");

        return (
            <button
                className={["muted action-bar-like", state.liked ? "liked" : ""].join(" ")}
                onClick={(e) => this.vote(e)}
                aria-label={aria_label}
            >
                <svg className="icon mr-1">
                    <use xlinkHref="#heart"></use>
                </svg>
                <span className="like-count">{state.like_count}</span>
            </button>
        );
    }
}
